import Vue from 'vue';

const VueUtils = require('./../modules/vue-utils');

Vue.component('throbber-overlay', require('./booking/ThrobberOverlay').default);
Vue.component('modal-dialog', require('./ModalDialog').default);
Vue.component('progress-bar', require('./ProgressBar').default);
Vue.component('vehicle-type-filter', require('./booking/VehicleTypeFilter').default);
Vue.component('vehicle-results', require('./booking/VehicleResults').default);
Vue.component('auto-suggest-input', require('./booking/AutoSuggestInput').default);
Vue.component('booking-insurance', require('./booking/BookingInsurance').default);
Vue.component('coupon-codes', require('./booking/CouponCodes').default);
Vue.component('flat-pickr', require('vue-flatpickr-component'));


function _uniqueId() {
    return `v-app-${(new Date).getTime()}`;
}

function _init() {
    const candidateElements = document.querySelectorAll('.v-app');

    if (candidateElements.length === 0) {
        return;
    }

    for (let el of candidateElements) {
        if (!el.hasAttribute('id')) {
            el.setAttribute('id', _uniqueId());
        }

        const id = '#' + el.getAttribute('id');

        const app = new Vue({
            el: id
        });

        VueUtils.addRefs(app.$refs);

        const elWithApp = document.querySelector(id);

        elWithApp._app = app;
    }
}

document.addEventListener('DOMContentLoaded', _init);
